"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Steps = function Steps(_ref) {
  var className = _ref.className,
      barClassName = _ref.barClassName,
      steps = _ref.steps,
      currentStep = _ref.currentStep,
      onCurrentStepChange = _ref.onCurrentStepChange;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex', className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex flex-col text-xl px-5 justify-center pt-12 shadow-xl', barClassName)
  }, steps.map(function (step, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: step.title,
      className: (0, _classnames["default"])('ml-5 pb-12 pl-5 relative border-l-2 last:border-transparent cursor-pointer border-gray-500', {
        'font-bold': index === currentStep
      }),
      onClick: function onClick() {
        onCurrentStepChange(index);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex items-center justify-center absolute w-5 h-5 rounded-sm top-0 left-0 transform -translate-x-1/2', {
        'bg-primary': index === currentStep,
        'bg-gray-500': index !== currentStep,
        'bg-red-500': !step.inputsAreValid && step.showError
      })
    }, step.inputsAreValid && /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.CheckOkSolid, {
      className: "w-4 h-4 fill-white"
    }), !step.inputsAreValid && step.showError && /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ErrorSolid, {
      className: "w-4 h-4 fill-white"
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('leading-8 text-primary', {
        'text-red-500': !step.inputsAreValid && step.showError
      })
    }, step.title));
  })), steps[currentStep].stepComponent);
};

Steps.propTypes = {
  currentStep: _propTypes["default"].number,
  className: _propTypes["default"].string,
  barClassName: _propTypes["default"].string,
  onCurrentStepChange: _propTypes["default"].func,
  steps: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    stepComponent: _propTypes["default"].node,
    title: _propTypes["default"].string,
    inputsAreValid: _propTypes["default"].bool,
    showError: _propTypes["default"].bool
  }))
};
Steps.defaultProps = {
  currentStep: 0,
  className: '',
  barClassName: '',
  onCurrentStepChange: function onCurrentStepChange() {},
  steps: []
};
var _default = Steps;
exports["default"] = _default;